export enum LeadStatus {
  Pending,
  Hold,
  Approved,
  Rejected,
  Trash,
}
